export const trackPromises = (promises: Promise<unknown>[], progress?: (progress: number) => void) => {
  let currentProgress = 0;
  function tick(promise: Promise<unknown>) {
    void promise.then(function () {
      currentProgress++;
      if (progress) progress(currentProgress / promises.length);
    });
    return promise;
  }

  return Promise.all(promises.map(tick));
};
